import React, { createContext, useContext } from "react";
import { useStaticQuery, graphql } from "gatsby";

const SiteConfigsContext = createContext();

export const useSiteConfigs = () => useContext(SiteConfigsContext);

export const SiteConfigsProvider = ({ children }) => {
 const data = useStaticQuery(graphql`
    query {
      contentfulSiteConfigs {
        title
        contactEmail
        instagramUrl
        youtubeUrl
        formEndpoint
      }
    }
  `);

 return (
  <SiteConfigsContext.Provider value={data.contentfulSiteConfigs}>
   {children}
  </SiteConfigsContext.Provider>
 );
};

